import GlitchP from "./GlitchP.vue";

export default GlitchP;
